interface SpeechRecognitionService {
  startListening: (onResult: (transcript: string) => void) => void;
  stopListening: () => void;
  isListening: () => boolean;
  isSupported: () => boolean;
}

class SpeechRecognitionServiceImpl implements SpeechRecognitionService {
  private recognition: any = null;
  private isListeningState: boolean = false;
  private onResultCallback: ((transcript: string) => void) | null = null;

  constructor() {
    // Verificar soporte del navegador
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.setupRecognition();
      console.log('[SPEECH] Reconocimiento de voz soportado');
    } else {
      console.warn('[SPEECH] Reconocimiento de voz no soportado en este navegador');
    }
  }

  private setupRecognition() {
    if (!this.recognition) return;

    // Configurar reconocimiento en español
    this.recognition.lang = 'es-ES';
    this.recognition.continuous = false;
    this.recognition.interimResults = false;
    this.recognition.maxAlternatives = 1;

    // Eventos
    this.recognition.onstart = () => {
      this.isListeningState = true;
      console.log('[SPEECH] Escuchando...');
    };

    this.recognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      console.log('[SPEECH] Texto reconocido:', transcript);
      
      if (this.onResultCallback) {
        this.onResultCallback(transcript);
      }
    };

    this.recognition.onerror = (event: any) => {
      console.error('[SPEECH] Error en reconocimiento:', event.error);
      this.isListeningState = false;
      
      if (event.error === 'no-speech') {
        console.log('[SPEECH] No se detectó voz');
      } else if (event.error === 'not-allowed') {
        console.error('[SPEECH] Permiso de micrófono denegado');
      }
    };

    this.recognition.onend = () => {
      this.isListeningState = false;
      console.log('[SPEECH] Reconocimiento finalizado');
    };
  }

  startListening(onResult: (transcript: string) => void) {
    if (!this.recognition) {
      console.error('[SPEECH] Reconocimiento de voz no soportado');
      return;
    }

    if (this.isListeningState) {
      console.log('[SPEECH] Ya está escuchando');
      return;
    }

    this.onResultCallback = onResult;
    
    try {
      this.recognition.start();
    } catch (error) {
      console.error('[SPEECH] Error al iniciar reconocimiento:', error);
    }
  }

  stopListening() {
    if (this.recognition && this.isListeningState) {
      this.recognition.stop();
      this.isListeningState = false;
      console.log('[SPEECH] Escucha detenida');
    }
  }

  isListening(): boolean {
    return this.isListeningState;
  }

  isSupported(): boolean {
    return this.recognition !== null;
  }
}

// Crear instancia singleton
export const speechRecognitionService = new SpeechRecognitionServiceImpl();
